// @ts-strict-ignore
import { ElementRef, EventEmitter, Input, Output, Directive } from '@angular/core';

@Directive()
export abstract class LMChartBase {

  @Input() dataset: SohoDataSet;
  @Input() type: string;
  @Input() showLegend: boolean;
  @Input() redrawOnResize: boolean;
  @Input() emptyMessage: {};
  @Input() animate: boolean;
  @Input() tooltip: string;

  // ------------------------------------------------------------------------
  // @Outputs
  // ------------------------------------------------------------------------

  @Output() selected = new EventEmitter<ChartEvent>();
  @Output() unselected = new EventEmitter<ChartEvent>();
  @Output() rendered = new EventEmitter<ChartEvent>();
  @Output() contextmenu = new EventEmitter<ChartEvent>();

  constructor(
    public elementRef: ElementRef,
  ) {
    const chartComponent = this;
    $(this.elementRef.nativeElement).on('contextmenu', function(e: JQuery.TriggeredEvent, ui, d) {
      const chartEvent: LMChartEvent = {
        event: e,
        ui,
        data: d,
      };
      chartComponent.contextmenu.emit(chartEvent);
    });
  }

  public abstract getChartComponent();

  public onSelected(event: ChartEvent) {
    this.selected.emit(event);
  }
  public onUnselected(event: ChartEvent) {
    this.unselected.emit(event);
  }
  public onRendered(event: ChartEvent) {
    this.rendered.emit(event);
  }
  public onContextMenu(event: ChartEvent) {
    if (event.event) {
      this.contextmenu.emit(event);
    } else {
      // event.stopPropagation();
    }
  }

  public getSelected() {
    return this.getChartComponent().getSelected();
  }

  public getChartOptions() {
    // return this._chartOptions;
    return {type: ''};
  }

  public setSelectDataIndex(index: number) {
    const data = this.dataset[0].data[index];
    const options = {fieldName: 'ref', fieldValue: data.ref};
    this.getChartComponent().setSelected(options);
  }

  private getRefIndex(data: Array<SohoDataSetItem>, index: number): number {
    const currentIndex = data.findIndex(record => index === record.ref
    );
    return currentIndex;
  }
  public setSelectRef(ref: any): void {
    if (this.getChartComponent()) {
      if (this.type === 'pie' || this.type === 'donut') {
        const selectOptions: SohoPieSelected = {fieldName: 'ref', fieldValue: ref};
        this.getChartComponent().setSelected(selectOptions);
      } else if (this.type.indexOf('grouped') >= 0 || this.type === 'area' || this.type === 'line' || this.type === 'bubble') {
        // let selectVal: string = this.dataset[ref].name;
        const selectOptions: LMChartGroupedSelection = {groupIndex: ref};
        this.getChartComponent().setSelected(selectOptions);
      } else {
        // let selectVal: string = this.dataset[ref].name;
        const selectOptions: LMChartSelection = {index: ref};
        this.getChartComponent().setSelected(selectOptions);
      }
    }
  }
}
